import { Section } from "@/components/ds/Section/Section";
import { Container } from "@/components/ds/Container/Container";
import { Stack } from "@/components/ds/Stack/Stack";
import { Row } from "@/components/ds/Row/Row";
import { Heading } from "@/components/ds/Heading/Heading";
import { Text } from "@/components/ds/Text/Text";
import { Badge } from "@/components/ds/Badge/Badge";
import { CheckCircleIcon } from "@/icons/CheckCircleIcon";
import { ClockIcon } from "@/icons/ClockIcon";
import { SmartphoneIcon } from "@/icons/SmartphoneIcon";
import { SignupForm } from "@/components/forms/SignupForm";
import { MockDashboard } from "./MockDashboard";
import styles from "./Hero.module.css";

export function Hero() {
  return (
    <Section background="cream" padding="lg" className={styles.section}>
      <Container>
        <div className={styles.hero}>
          <div className={styles.content}>
            <Stack gap={6}>
              <Heading level={1} size="h2">
                Rotas and attendance reports
                <br />
                for cleaning companies who&apos;ve{" "}
                <span className={styles.accent}>outgrown spreadsheets.</span>
              </Heading>
              <Text size="lg" color="primary">
                No more chasing cleaners on WhatsApp. One live screen shows
                every cleaner and every GPS-verified check-in, so you spot a
                late arrival before your client does. The whole operation,
                finally in your hands.
              </Text>
              <SignupForm />
              <Row gap={4}>
                <Badge variant="success">
                  <CheckCircleIcon width={14} height={14} />
                  14 days free
                </Badge>
                <Badge variant="neutral">
                  <ClockIcon width={14} height={14} />
                  Set up in 10 minutes
                </Badge>
                <Badge variant="neutral">
                  <SmartphoneIcon width={14} height={14} />
                  No app install for your cleaners
                </Badge>
              </Row>
            </Stack>
          </div>
          <div className={styles.mockup}>
            <MockDashboard />
          </div>
        </div>
      </Container>
    </Section>
  );
}
